import { render, staticRenderFns } from "./GameRule.vue?vue&type=template&id=47d5ffbf&scoped=true"
import script from "./GameRule.vue?vue&type=script&lang=js"
export * from "./GameRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d5ffbf",
  null
  
)

export default component.exports